export const convertStringToKey = (str) => {
  return str.replace(/\s+/g, '-').toLowerCase();
};
